/* eslint-disable react/prop-types */
import classNames from 'classnames';
import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import styles from './Gdpr.module.scss';
import { useCookies } from 'react-cookie';
import loadable from '@loadable/component';

const Button = loadable(() => import('../Button/Button'));

const COOKIE_NAME = 'TT_cookies_allowed';
const cookieExpirationDate = new Date();
cookieExpirationDate.setFullYear(cookieExpirationDate.getFullYear() + 1);

const Gdpr = ({ config }) => {
  const [cookies, setCookie] = useCookies([COOKIE_NAME]);
  const cookiesAllowed = cookies[COOKIE_NAME];

  const grantUserConsent = useCallback(() => {
    setCookie(COOKIE_NAME, 1, {
      expires: cookieExpirationDate,
      path: '/',
    });
    //Allow MS Clarity to use cookies
    //https://learn.microsoft.com/en-us/clarity/setup-and-installation/cookie-consent
    if (window.clarity) window.clarity('consent');
  }, [setCookie]);

  useEffect(() => {
    if (cookiesAllowed) {
      grantUserConsent();
    }
  }, [cookiesAllowed, grantUserConsent]);

  if (cookiesAllowed) {
    return null;
  }

  return (
    <div className={styles.gdpr} data-testid="gdpr">
      <div className="container">
        <div className="row">
          <div className={classNames(styles.gdprContent, 'col-12-xs')}>
            <div className={styles.gdprContentText}>
              <FormattedMessage
                id="common.cookie.message"
                values={{ webShopName: config.websiteName }}
                defaultMessage="We use cookies to improve our site and your shopping experience. By continuing to browse our site, you are accepting our cookie policy."
              />{' '}
              <Link to={`/${config.cmsSlugs.cookies}/#cookies`}>
                <FormattedMessage id="common.cookie.linkText" defaultMessage="" />
              </Link>{' '}
              <FormattedMessage id="common.cookie.messageEnd" defaultMessage="" />
            </div>
          </div>
          <Button
            classList={{ root: classNames(styles.accept, 'col-12-xs', 'col-6-xl') }}
            onClick={grantUserConsent}
            variation={'primary'}
            data-testid="gdprSetCookie"
          >
            <FormattedMessage id="common.cookie.accept" defaultMessage="Accept" />
          </Button>
          <Link className={classNames(styles.noLine, 'col-12-xs', 'col-6-xl')} to={`/${config.cmsSlugs.privacy}/`}>
            <Button inverted variation={'primary'}>
              <FormattedMessage id="common.cookie.link" defaultMessage="Find out more" />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

Gdpr.displayName = 'Gdpr';

export const mapStatesToProp = ({ config }) => ({ config });
export default connect(mapStatesToProp)(Gdpr);
